<template>
  <div class="credit-list-wrap">
    <el-breadcrumb separator=">" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>融资管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>授信申请列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-wrap">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">融资产品名称</span>
        <el-input v-model.trim="tableOptions.platformProductName" :maxlength="32" placeholder="请输入" clearable>
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">授信状态</span>
        <el-select
          style="width: 150px"
          v-model="tableOptions.applicationStatus"
          placeholder="请选择"
          class="track-elselect"
        >
          <el-option v-for="(item, idx) in applicationStatusList" :label="item.label" :value="item.value" :key="idx">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" @click="handleSearch" id="auto-4">筛选</el-button>
        <el-button class="custom-reset-btn" @click="resetOption" id="auto-5">重置</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 授信申请记录 </span>
      </div>
      <div class="fr">
        <el-button type="primary" id="auto-6" @click="handleApply"><span class="apply-icon"></span>申请授信</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-7">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <!-- 申请时间 -->
        <template #applicationDate="{ scope }">
          <span>{{ scope.row.applicationDate | stamp2TextDateFull(2) }}</span>
        </template>
        <!-- 授信编号 -->
        <template #applicationNo="{ scope }">
          <div class="font-blue pointer" @click="showDetail(scope.row)">
            {{ scope.row.applicationNo }}
          </div>
        </template>
        <!-- 授信状态 -->
        <template #applicationStatus="{ scope }">
          <span
            :class="{ abort: scope.row.applicationStatus == 2, pass: scope.row.applicationStatus == 1 }"
            class="application-status"
            >{{ scope.row.applicationStatusDesc }}</span
          >
        </template>
        <!-- 授信有效期 -->
        <template #approvalStartDate="{ scope }">
          <span v-if="scope.row.approvalStartDate"
            >{{ scope.row.approvalStartDate | stamp2TextDate }} 至
            {{ scope.row.approvalEndDate | stamp2TextDate }}</span
          >
          <span v-else></span>
        </template>
        <!-- 授信额度 -->
        <template #approvalAmount="{ scope }">
          <span>{{ scope.row.approvalAmount | thousands(2) }}</span>
        </template>
      </fe-table>
    </div>
  </div>
</template>
<script>
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';
export default {
  mixins: [tableMixin],
  data() {
    return {
      columns: [
        { label: '申请时间', prop: 'applicationDate', 'min-width': 100 },
        { label: '授信编号', prop: 'applicationNo', 'min-width': 100 },
        { label: '融资产品名称', prop: 'platformProductName', 'min-width': 100 },
        { label: '授信状态', prop: 'applicationStatus', 'min-width': 80 },
        { label: '授信有效期', prop: 'approvalStartDate', 'min-width': 120 },
        { label: '授信额度', prop: 'approvalAmount', 'min-width': 100 }
      ],
      tableOptions: {
        platformProductName: '',
        applicationStatus: null
      },
      axiosConfig: { url: api.creditApplyList },
      applicationStatusList: [
        { value: null, label: '全部' },
        { value: 0, label: '审核中' },
        { value: 1, label: '已通过' },
        { value: 2, label: '已拒绝' }
      ]
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    handleApply() {
      this.$router.push({ path: '/credit/apply' });
    },
    showDetail(row) {
      this.$router.push({ path: `/credit/apply/detail/${row.applicationNo}` });
    }
  }
};
</script>
<style lang="postcss" scoped>
.credit-list-wrap {
  margin: 6px;
  .apply-icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    background: url('../../assets/img/finance/credit_apply_icon.png') no-repeat;
    background-size: 16px 16px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }
  .loan-status {
    padding: 2px 6px;
    border-radius: 2px;
    border: 1px solid #aaaaaa;
    color: #aaa;
    &.active {
      color: #01d28e;
      border: 1px solid #01d28e;
    }
  }
  .application-status {
    position: relative;
    padding-left: 12px;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 5px;
      width: 6px;
      height: 6px;
      background: #3399ff;
      border-radius: 50%;
    }
    &.pass {
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 5px;
        width: 6px;
        height: 6px;
        background: #01d28e;
        border-radius: 50%;
      }
    }
    &.abort {
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 5px;
        width: 6px;
        height: 6px;
        background: #f35856;
        border-radius: 50%;
      }
    }
  }
}
</style>
